import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Items } from '../../Routes';
import $ from 'jquery';

const Menu = (props) => {
    const handleToggle = () => {
        $(this).toggleClass('open')
        $('#navigation').slideToggle(400);
    }
    return (
        <div className="topbar-custom">
            <ul className="list-inline float-left mb-0">
                <li className="list-inline-item dropdown">
                    <a className="navbar-toggle nav-link" onClick={handleToggle}>
                        <div id={props.id}></div>
                    </a>
                    <a className="navbar-dropdown nav-link dropdown-toggle" id="dropdownMenu" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className="list-inline">
                            <span id={props.id} className="list-inline-item"></span>
                        </div>
                    </a>
                    <div className="dropdown-menu dropdown-lg" aria-labelledby="dropdownMenu">
                        { Items.slice(4, -1).map((item, index) => { 
                            return <Link key={index} className="dropdown-item" to={item.path}><FormattedMessage id={item.name}/></Link> 
                        }) }
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default Menu;